import CircularProgress, {
    circularProgressClasses,
  } from '@mui/material/CircularProgress';
  import { Box,Typography } from '@mui/material';
  import styles from "../../styles/proposal/circularPercentage.module.css";
  
  type CircularPercentageProps = {
    percent:number;
  }

const CircularPercentage = (props:CircularPercentageProps) => {
    let color = "#607d8b";
    let percent_s:string;
    let percent_n:number;
    if (props.percent >100){
      color="#ad1457";
      percent_s = ">100%";
      percent_n=100
    } else {
      percent_n = props.percent;
      percent_s = props.percent+`%`
    }

    return (
        <Box sx={{ position: 'relative',display: 'inline-flex' }}>
          <CircularProgress
        variant="determinate"
        sx={{
          color: "#cfd8dc",
        }}
        size={60}
        thickness={4}
        {...props}
        value={100}
      />
      <CircularProgress
        variant="determinate"
        sx={{
          color: {color},
          position: 'absolute',
          left: 0,
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: 'round',
          },
        }}
        size={60}
        thickness={4}
        value={percent_n}
      />
           <Box className={styles.box}>
        <Typography
          variant="caption"
          component="div"
          color="text.secondary"
        >{percent_s}</Typography>
      </Box>
        </Box>
      );
}

export default CircularPercentage